// import React, { useState, useEffect } from 'react';
// import AddButton from '../../../components/common/AddButton/AddButton';
// import Filter from '../../../components/common/Filter/Filter';
// import Sort from '../../../components/common/Sort/Sort';
// import ExportLabel from '../../../components/common/ExportLabel/Export';
// import PageHeader from '../../../components/common/PageHeader/PageHeader';
// import SimpleSearchBox from '../../../components/common/Search/SimpleSearch';
// import ArchiveSelectedItem from '../../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
// import './ReleaseNotes.css';
// import { useNavigate } from 'react-router-dom';
// // import AddButtonWithPlus from '../../../components/common/AddButton/AddButtonWithPlus';


// const ReleaseNotes = () => {
//   const [items, setItems] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const navigate = useNavigate();

//   const handleNewClick = () => {
//     navigate('/add-release-notes');
//   }

//   useEffect(() => {
//     fetchItems();
//   }, []);

//   const fetchItems = async () => {
//     const release = [
//       {
//         version: "v2.4.1",
//         title: "AI Route Optimization Update",
//         newNum: 2,
//         impNum: 1,
//         bugNum: 6,
//         date: "Mar 12, 2026",
//         status: "Draft"
//       },
//       {
//         version: "v2.4.0",
//         title: "Advanced GPS Tracking",
//         newNum: 1,
//         impNum: 1,
//         bugNum: 3,
//         date: "Mar 01, 2026",
//         status: "Published"
//       },
//       {
//         version: "v2.3.0",
//         title: "Distributor Analytics",
//         newNum: 2,
//         impNum: 1,
//         bugNum: 3,
//         date: "Feb 18, 2026",
//         status: "Published"
//       }
//     ]
//     setItems(release);
//   };


//   return (
//     <div className='whole-container'>
//       <div className='top-heading'>
//         <PageHeader pageName="Engagement /" nestedpageName="Release Notes" linkTo="" />
//         <div className='export-container'>
//           <ArchiveSelectedItem selectedItems={selectedItems} />
//           <ExportLabel />
//         </div>
//       </div>
//       <div className='pagename-container'>
//         <div className='page-name'>
//           <h1 className='common-text fts-22 ftw-6 blue'>Release Notes</h1>
//         </div>
//         <div className='pagename-right-container'>
//           <AddButton onClick={handleNewClick} />
//           <SimpleSearchBox placeholder="Search" />
//           <Filter />
//           <Sort />
//         </div>
//       </div>
//       <div className='table-container'>
//         <table className='common-table'>
//           <thead className='common-table-head'>
//             <tr className='common-table-thead-tr'>
//               <th>
//                 <input
//                   className="table-selectbox table-parent-selectbox"
//                   type="checkbox"
//                 />VERSION
//               </th>
//               <th>TITLE</th>
//               <th>NEW FEATURES</th>
//               <th>IMPROVEMENTS</th>
//               <th>BUG FIXES</th>
//               <th>RELEASE DATE</th>
//               <th>STATUS</th>
//             </tr>
//           </thead>

//           <tbody className="common-table-tbody">
//             {items.map((release, index) => (
//               <tr key={index}>
//                 <td className='d-flex ai-center'>
//                   <input
//                     className="table-selectbox table-child-selectbox"
//                     type="checkbox"

//                   />{release.version}
//                 </td>
//                 <td>{release.title}</td>
//                 <td>{release.newNum}</td>
//                 <td>{release.impNum}</td>
//                 <td>{release.bugNum}</td>
//                 <td>{release.date}</td>
//                 <td className="actions common-action">
//                   {release.status === "Published" ? (
//                     <div className='release-published-cont'>
//                       <span className='release-published'>Published</span>
//                     </div>
//                   ) : release.status === "Draft" ? (
//                     <div className='release-draft-cont'>
//                       <span className='release-draft'>Draft</span>
//                     </div>
//                   ) : null}

//                 </td>
//               </tr>
//             ))}
//             {/* {items.length === 0 ? (
//               <div className="empty-state">No Release Notes Found</div>
//             ) : (
//               <table>...</table>
//             )} */}
//           </tbody>
//         </table>
//       </div>
//       <div>

//       </div>


//     </div>
//   );
// };

// export default ReleaseNotes;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import AddButton from '../../../components/common/AddButton/AddButton';
import Filter from '../../../components/common/Filter/Filter';
import Sort from '../../../components/common/Sort/Sort';
import ExportLabel from '../../../components/common/ExportLabel/Export';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import SimpleSearchBox from '../../../components/common/Search/SimpleSearch';
import ArchiveSelectedItem from '../../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';

import authenticatedAxios from '../../../authenticatedAxios';
import { baseurl } from '../../../api';
import { useCheckboxClick } from '../../../checkboxclick';
import useFilterStore from '../../../store/useFilterStore';
import useRefreshStore from '../../../store/useRefreshStore';

import './ReleaseNotes.css';

const pageKey = "release_notes";

const ReleaseNotes = () => {
  const navigate = useNavigate();

  // ── Filter / sort / search persistence (same as OurPlans) ────────────────────
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);

  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const [searchParams,          setSearchParams]          = useState(savedFilters?.searchParams          || { term: "" });
  const [selectedFilterOption,  setSelectedFilterOption]  = useState(savedFilters?.selectedFilterOption  || "Unarchived");
  const [selectedSortOption,    setSelectedSortOption]    = useState(savedFilters?.selectedSortOption    || "Newest");

  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Release Notes"] || 0;

  const {
    isParentSelected,
    selectedItems,
    handleParentCheckboxChange,
    handleChildCheckboxChange,
    resetCheckboxState,
  } = useCheckboxClick(items);

  const sortOptions   = ['Newest', 'Oldest', 'A-Z', 'Z-A'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];

  // ── Fetch on mount + whenever search / filter / sort changes ─────────────────
  useEffect(() => {
    fetchReleaseNotes();
    setFilters(pageKey, { searchParams, selectedFilterOption, selectedSortOption });
  }, [searchParams, selectedSortOption, selectedFilterOption]);

  // ── Re-fetch when refresh store triggers ─────────────────────────────────────
  useEffect(() => {
    fetchReleaseNotes();
  }, [refreshKey]);

  // ─── Fetch (list or single item) — same signature as OurPlans.fetchPlans ─────
  const fetchReleaseNotes = async (id = null, action = null) => {
    try {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort:   mapSortOptionToQuery(selectedSortOption),
        };
        const response = await authenticatedAxios.get(
          `${baseurl}release-notes/list/`,
          { params }
        );
        // Support both { data: [...] } and plain array responses
        const data = response.data?.data ?? response.data;
        if (Array.isArray(data)) setItems(data);
      
    } catch (error) {
      console.error("Error fetching release notes:", error);
    }
  };

  

  

  // ─── Sort helper ──────────────────────────────────────────────────────────────
  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':    return 'a_to_z';
      case 'Z-A':    return 'z_to_a';
      case 'Newest': return 'newest';
      case 'Oldest': return 'oldest';
      default:       return 'newest';
    }
  };

  // ─── Handlers ─────────────────────────────────────────────────────────────────
  const handleNewClick    = () => navigate('/release-notes/create');
  const handleSearchSelect = (term) => setSearchParams((prev) => ({ ...prev, term }));
  const handleSortOptionSelect  = (option) => setSelectedSortOption(option);
  const handleFilterSelect      = (option) => setSelectedFilterOption(option);


  const handleDetailsClick = (item,id) => {
    navigate(`/release-notes/detail/${id}`, { state: { note: item } });
  };

  const formatDate = (date) => {
    if (!date) return '—';

    const d = new Date(date);

    return d.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };


  // ─── Render ───────────────────────────────────────────────────────────────────

  return (
    <div className="whole-container">

      <div className="top-heading">
        <PageHeader pageName="Engagement /" nestedpageName="Release Notes" linkTo="" />
        <div className="export-container">
          {/* <ArchiveSelectedItem
           selectedItems={selectedItems} /> */}
          {/* <ExportLabel/> */}
        </div>
      </div>

      <div className="pagename-container">
        <div className="page-name">
          <h1 className="common-text fts-22 ftw-6 blue">Release Notes</h1>
        </div>
        <div className="pagename-right-container">
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox
            placeholder="Search Release Notes"
            onSearchSelect={handleSearchSelect}
            defaultValue={searchParams?.term}
          />
          {/* <Filter
            options={filterOptions}
            onFilterSelect={handleFilterSelect}
            defaultValue={selectedFilterOption}
          /> */}
          <Sort
            options={sortOptions}
            onOptionSelect={handleSortOptionSelect}
            defaultValue={selectedSortOption}
          />
        </div>
      </div>

      <div className="table-container">
        <table className="common-table">
          <thead className="common-table-head">
            <tr className="common-table-thead-tr">
              <th className="d-flex ai-center release-list">
                VERSION
              </th>
              <th>TITLE</th>
              <th>NEW FEATURES</th>
              <th>IMPROVEMENTS</th>
              <th>BUG FIXES</th>
              <th>RELEASE DATE</th> 
              <th>STATUS</th>
            </tr>
          </thead>

          <tbody className="common-table-tbody">
            {items.map((release) => (
              <tr
                key={release.id}
               onClick={() => handleDetailsClick(release, release.id)}
                className={release.is_archived ? 'archived-item' : ''}
                style={{ cursor: "pointer" }}
              >
                <td className="d-flex ai-center release-list">
                  {/* <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(release.id)}
                    onChange={() => handleChildCheckboxChange(release.id)}
                  /> */}
                  {release.version}
                </td>
                <td>{release.title}</td>
                <td>{release.features?.length     ?? 0}</td>
                <td>{release.improvements?.length ?? 0}</td>
                <td>{release.bug_fixes?.length    ?? 0}</td>
                <td>{formatDate(release.release_date)}</td>
                <td>
                  {release.status === 'published' ? (
                    <div className="release-published-cont">
                      <span className="release-published">Published</span>
                    </div>
                  ) : (
                    <div className="release-draft-cont">
                      <span className="release-draft">Draft</span>
                    </div>
                  )}
                </td>
                {/* <td className="actions common-action">
                  <DetailIcon onClick={() => handleDetailClick(release)} />
                  <EditIcon   onClick={() => handleEditClick(release)} />
                  <ArchiveIcon
                    onClick={() => handleArchiveClick(release)}
                    isArchived={release.is_archived}
                  />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      
    </div>
  );
};

export default ReleaseNotes;